import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Loading } from "../../components/Loading";
import { MainButton } from "../../components/MainButton";
import { ConfigType } from "../../contexts/AppConfigContext";
import { useAppConfig } from "../../hooks/useAppConfig";
import { usePluginspace } from "../../hooks/usePluginspace";
import "./index.css";
import Swal from "sweetalert2";
import api from "../../services/api";
import InputMask from "react-input-mask";
import { Checkbox } from "../../components/Checkbox";
import { telephoneNoMask } from "../../functions/mask";
import { ModalTerms } from "../../components/ModalTerms";
import { useToast } from "../../hooks/useToast";
import ReactLoading from "react-loading";
import { useFoodConfig } from "../../hooks/useFood";
import { ModalQueue } from "../../components/ModalQueue";

type ImageType = {
  id: string;
  url: string;
};

type QueueConfigType = {
  id: string;
  able: boolean;
  limitPeople: number;
  limitPeopleGroup: number;
  limitTime: number;
  images: ImageType[];
  useTerms: boolean;
  useMenu: boolean;
  useLocation: boolean;
  useNinegridMenu: boolean;
  externalMenuLink: string;
  limitQueue: number;
};

export function Queue() {
  const { pluginspace_id } = useParams();
  const { registerAccess, getToken, getVerifyShift, getThisPluginspace } =
    usePluginspace();
  const navigate = useNavigate();

  const { getAppConfig } = useAppConfig();
  const [config, setConfig] = useState<ConfigType | void>();
  const [loading, setLoading] = useState(true);
  const [loaderLocation, setLoaderLocation] = useState(false);
  const [queueConfig, setQueueConfig] = useState<QueueConfigType | null>(null);
  const [people, setPeople] = useState(0);
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [phoneFind, setPhoneFind] = useState("");
  const [maskTelephone, setMaskTelephone] = useState("(99) 9999-9999");
  const [maskTelephoneFind, setMaskTelephoneFind] = useState("(99) 9999-9999");
  const [acceptTerm, setAcceptTerm] = useState(false);
  const [term, setTerm] = useState("");
  const [openTerms, setOpenTerms] = useState(false);
  const [validShift, setValidShift] = useState(false);
  const [preferentialQueue, setPreferentialQueue] = useState("n");
  const [locationShop, setLocationShop] = useState<any>();

  const toastComponent = useToast();

  const useFood = useFoodConfig();

  useEffect(() => {
    registerAccess("queue");
    init();
  }, []);

  async function init() {
    setLoading(true);
    toastComponent.setToastPosition("0rem");
    setValidShift(await getVerifyShift());
    await getConfig();
    await getQueueConfig();
    await getTerms();
    await updateLocationShop();
    setLoading(false);
  }

  const updateLocationShop = async () => {
    const res: any = await getThisPluginspace();
    setLocationShop(res);
  };

  async function getTerms() {
    await api
      .post(
        `/api/consent/filter`,
        {
          active: true,
        },
        {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        }
      )
      .then(async (response) => {
        if (response.data.data && response.data.data[0]) {
          setTerm(response.data.data[0].content);
        } else {
          setTerm("");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  async function getQueueConfig() {
    await api
      .get("/api/queueReservation/queueConfig", {
        headers: {
          Authorization: `Bearer ${await getToken()}`,
        },
      })
      .then((response) => {
        const queueResponse = response.data;
        if (queueResponse && queueResponse.data && queueResponse.data[0]) {
          const queueConfigItem = queueResponse.data[0];
          if (queueConfigItem && queueConfigItem.able) {
            setQueueConfig(queueConfigItem);
          } else {
            Swal.fire({
              icon: "error",
              title: "Fila não está habilitada!",
              text: "Loja não está com o esquema de filas habilitada.",
            }).then(() => navigate(`/${pluginspace_id}`));
          }
        } else {
          Swal.fire({
            icon: "error",
            title: "Fila não configurada!",
            text: "Loja não está com o esquema de filas configurada.",
          }).then(() => navigate(`/${pluginspace_id}`));
        }
      })
      .catch((err) => {
        console.log(err);
        Swal.fire({
          icon: "error",
          title: "Fila não configurada!",
          text: "Loja não está com o esquema de filas configurada.",
        }).then(() => navigate(`/${pluginspace_id}`));
      });
  }
  async function habilitarGeolocalizacao() {
    try {
      if ("geolocation" in navigator) {
        // Return a Promise that resolves or rejects based on the geolocation result
        const position: any = await new Promise((resolve, reject) => {
          navigator.geolocation.getCurrentPosition(
            (position) => resolve({ success: true, data: position }),
            (error) => {
              let errorMessage = "";

              switch (error.code) {
                case error.PERMISSION_DENIED:
                  errorMessage =
                    "Você bloqueou a permissão de localização. Para continuar, vá até as configurações do dispositivo e toque em “redefinir permissões”. Em seguida, tente novamente.";
                  break;
                case error.POSITION_UNAVAILABLE:
                  errorMessage = "A localização está indisponível.";
                  break;
                case error.TIMEOUT:
                  errorMessage = "Tempo limite para obter a localização.";
                  break;
                default:
                  errorMessage =
                    "Ocorreu um erro desconhecido ao obter a localização.";
                  break;
              }

              toastComponent.openToast("warning", errorMessage, 8000);
              reject({ success: false, error: error });
            }
          );
        });

        return position;
      } else {
        toastComponent.openToast(
          "warning",
          "Geolocalização não é suportada pelo seu navegador.",
          8000
        );
        return { success: false, data: {} };
      }
    } catch (error) {
      return { success: false, error: error };
    }
  }

  async function enterQueue() {
    let latCliente = 0;
    let longCliente = 0;
    let distanciaCalc = 0;

    if (!validShift) {
      toastComponent.openToast(
        "warning",
        "Loja fechada, impossível entrar na fila.",
        4000
      );
      /* Swal.fire({
                icon: 'warning',
                title: 'Atenção!',
                text: 'Loja fechada, impossível entrar na fila.',
            })*/
      return;
    }

    if (
      !acceptTerm &&
      term !== "" &&
      term &&
      queueConfig &&
      queueConfig.useTerms
    ) {
      toastComponent.openToast(
        "error",
        "É necessário aceitar os termos para continuar.",
        4000
      );
      /* Swal.fire({
                icon: 'error',
                title: 'Erro',
                text: 'É necessário aceitar os termos para continuar.',
            })*/
      return;
    }
    if (people <= 0) {
      toastComponent.openToast(
        "warning",
        "Precisa haver uma pessoa ou mais para entrar na fila.",
        4000
      );
      /*
            Swal.fire({
                icon: 'warning',
                title: 'Atenção!',
                text: `Precisa haver uma pessoa ou mais para entrar na fila.`,
            })*/
      return;
    }

    if (queueConfig && people > queueConfig.limitPeopleGroup) {
      toastComponent.openToast(
        "warning",
        `Há mais pessoas do que o permitido na fila de espera (Máximo ${queueConfig.limitPeopleGroup})`,
        4000
      );
      /*Swal.fire({
                icon: 'warning',
                title: 'Atenção!',
                html: `Há mais pessoas do que o permitido na fila de espera (Máximo ${queueConfig.limitPeopleGroup})`,
            })*/
      return;
    }

    if (!name) {
      toastComponent.openToast(
        "warning",
        `É necessário adicionar um nome para entrar na fila.`,
        4000
      );
      /*Swal.fire({
                icon: 'warning',
                title: 'Atenção!',
                text: `É necessário adicionar um nome para entrar na fila.`,
            })*/
      return;
    }

    if (!name.split(" ")[1]) {
      toastComponent.openToast(
        "warning",
        `É necessário adicionar um sobrenome para entrar na fila.`,
        4000
      );
      /* Swal.fire({
                icon: 'warning',
                title: 'Atenção!',
                text: `É necessário adicionar um sobrenome para entrar na fila.`,
            })*/
      return;
    }

    if (!phone || phone.includes("_")) {
      toastComponent.openToast("warning", `Celular inválido.`, 4000);
      /* Swal.fire({
                icon: 'warning',
                title: 'Atenção!',
                text: `Celular inválido.`,
            })*/
      return;
    }

    const subscriptionStorage = localStorage.getItem(
      window.btoa("subscription_notification")
    );
    let subscription = null;
    if (
      subscriptionStorage &&
      window.atob(subscriptionStorage) &&
      JSON.parse(window.atob(subscriptionStorage))
    ) {
      subscription = JSON.parse(window.atob(subscriptionStorage));
    }

    setLoading(true);

    if (queueConfig && queueConfig.useLocation) {
      setLoaderLocation(true);

      const habilitadoLocalizacao = await habilitarGeolocalizacao();

      latCliente = habilitadoLocalizacao.data.coords.latitude;
      longCliente = habilitadoLocalizacao.data.coords.longitude;

      const distancia = useFood.calculateDistance(
        parseFloat(locationShop.address.lat),
        parseFloat(locationShop.address.lng),
        parseFloat(habilitadoLocalizacao.data.coords.latitude),
        parseFloat(habilitadoLocalizacao.data.coords.longitude)
      );

      distanciaCalc = distancia;

      const res = distancia * 1000 <= queueConfig.limitQueue;
      setLoaderLocation(false);

      if (!res) {
        toastComponent.openToast(
          "error",
          `É necessário estar próximo ao estabelecimento para entrar na fila.`,
          4000
        );

        setLoading(false);
        return null;
      }

      if (!habilitadoLocalizacao || !habilitadoLocalizacao.success) {
        setLoading(false);
        return null;
      }
    }

    await api
      .post(
        "/api/queueReservation/queue",
        {
          people: parseInt(people.toString()),
          name,
          phone: telephoneNoMask(phone),
          preferential: preferentialQueue === "y" ? true : false,
          subscription,
          urlNotification: window.location.href + "/" + telephoneNoMask(phone),
        },
        {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        }
      )
      .then((response) => {
        setLoading(false);
        const queueResponse = response.data;
        if (queueResponse.success) {
          navigate(`/${pluginspace_id}/queue/${telephoneNoMask(phone)}`, {
            state: {
              latLoja: locationShop.address.lat,
              longLoja: locationShop.address.lng,
              latCliente: latCliente,
              longCliente: longCliente,
              calculo: distanciaCalc * 1000,
            },
          });
        } else {
          toastComponent.openToast(
            "error",
            `Não foi possível entrar na fila.`,
            4000
          );
        }
      })
      .catch((err) => {
        setLoading(false);
        let title = "Erro ao entrar na fila!";
        let text = "Não foi possível entrar na fila.";
        if (
          err &&
          err.response &&
          err.response.data &&
          err.response.data.error
        ) {
          title = err.response.data.error;
        }
        if (
          err &&
          err.response &&
          err.response.data &&
          err.response.data.message
        ) {
          text = err.response.data.message;
        }

        toastComponent.openToast("error", text, 4000);
      });
  }

  async function getConfig() {
    setConfig(await getAppConfig());
  }

  function changePhone(newPhone: string) {
    const phoneValidated = newPhone.replaceAll("_", "");
    if (phoneValidated.length >= 14 && phoneValidated[13] !== "_") {
      setMaskTelephone("(99) 99999-9999");
    } else {
      setMaskTelephone("(99) 9999-9999");
    }
  }

  function changePhoneFind(newPhone: string) {
    const phoneValidated = newPhone.replaceAll("_", "");
    if (phoneValidated.length >= 14 && phoneValidated[13] !== "_") {
      setMaskTelephoneFind("(99) 99999-9999");
    } else {
      setMaskTelephoneFind("(99) 9999-9999");
    }
  }

  return (
    <div className="queue">
      {loading ? (
        <div style={{ width: "100%", height: "calc(100vh)" }}>
          <Loading type="spinningBubbles" color="#FFF" width={64} height={64} />
        </div>
      ) : (
        <div className="content-queue">
          {!validShift && (
            <div
              className="queue-label"
              style={{
                backgroundColor: config?.webappcolor.backgroundtitlebar
                  ? config.webappcolor.backgroundtitlebar
                  : "#000000",
              }}
            >
              <span
                style={{
                  color: config?.webappcolor.fonttitlebar
                    ? config.webappcolor.fonttitlebar
                    : "#FFFFFF",
                }}
              >
                Loja Fechada
              </span>
            </div>
          )}
          {queueConfig && (
            <div className="body-queue">
              {queueConfig.images && queueConfig.images[0] && (
                <div className="queue-image">
                  <img src={queueConfig.images[0].url} alt="Imagem Fila 1" />
                </div>
              )}
              <div className="queue-form">
                <h2>Fila de espera</h2>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    gap: "20px",
                  }}
                >
                  <div
                    className="input"
                    style={{ width: "100%", marginTop: "0.7em" }}
                  >
                    <label>Número de pessoas</label>
                    <input
                      type="number"
                      value={people ? people : ""}
                      onChange={(event) =>
                        setPeople(parseInt(event.target.value))
                      }
                      placeholder="0"
                      max={queueConfig.limitPeople}
                      min={0}
                    />
                  </div>
                  <div
                    className="input-preferencial"
                    style={{ width: "100%", marginTop: "0.7em" }}
                  >
                    <label>Fila preferencial</label>
                    <select
                      onChange={(e) => setPreferentialQueue(e.target.value)}
                      value={preferentialQueue}
                    >
                      <option value="y">Sim</option>
                      <option value="n">Não</option>
                    </select>
                  </div>
                </div>
                <div className="input">
                  <label>Nome completo</label>
                  <input
                    type="text"
                    value={name}
                    onChange={(event) => {
                      const isValidName = /^[a-zA-ZÀ-ÿ\s]*$/.test(
                        event.target.value
                      );
                      if (isValidName) setName(event.target.value);
                    }}
                  />
                </div>
                <div className="input">
                  <label>Celular</label>
                  <InputMask
                    mask={maskTelephone}
                    type="text"
                    value={phone}
                    onBeforeInputCapture={(event) =>
                      changePhone(event.currentTarget.value)
                    }
                    onChange={(event) => setPhone(event.target.value)}
                  />
                </div>
                {/* { term !== '' && (
                            <div className="input-checkbox">
                                <Checkbox name='accept' checked={acceptTerm} checkMark={() => setAcceptTerm(!acceptTerm)} />
                                <label style={{cursor: 'pointer'}} onClick={() => setOpenTerms(true)} htmlFor="accept">Aceito os termos de uso de dados</label>
                            </div>
                            )} */}
                {acceptTerm || !queueConfig.useTerms ? (
                  <div className="button-queue">
                    <MainButton
                      color={
                        config?.webappcolor.fontbutton
                          ? config.webappcolor.fontbutton
                          : "#636363"
                      }
                      backgroundColor={
                        config?.webappcolor.webappbutton
                          ? config.webappcolor.webappbutton
                          : "#EAEAEA"
                      }
                      text={
                        loaderLocation
                          ? "Entrar na fila de espera"
                          : "Entrar na fila de espera →"
                      }
                      onClick={() => enterQueue()}
                      loaderIcon={loaderLocation}
                    />
                  </div>
                ) : (
                  <div className="button-queue">
                    <MainButton
                      color={
                        config?.webappcolor.fontbutton
                          ? config.webappcolor.fontbutton
                          : "#636363"
                      }
                      backgroundColor={
                        config?.webappcolor.webappbutton
                          ? config.webappcolor.webappbutton
                          : "#EAEAEA"
                      }
                      text="Termos de Consentimento"
                      onClick={() => setOpenTerms(true)}
                    />
                  </div>
                )}
                <div className="already-queue">
                  <h3>Já está na fila de espera?</h3>
                  <p>Informe o seu telefone abaixo para ver a sua posição</p>
                  <div className="input">
                    <label>Celular</label>
                    <InputMask
                      mask={maskTelephoneFind}
                      type="text"
                      value={phoneFind}
                      onBeforeInputCapture={(event) =>
                        changePhoneFind(event.currentTarget.value)
                      }
                      onChange={(event) => setPhoneFind(event.target.value)}
                    />
                  </div>
                  <div className="button-queue">
                    <MainButton
                      color={
                        config?.webappcolor.fontbutton
                          ? config.webappcolor.fontbutton
                          : "#636363"
                      }
                      backgroundColor={
                        config?.webappcolor.webappbutton
                          ? config.webappcolor.webappbutton
                          : "#EAEAEA"
                      }
                      text="Procurar"
                      onClick={() =>
                        navigate(
                          `/${pluginspace_id}/queue/${telephoneNoMask(
                            phoneFind
                          )}`
                        )
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
          {openTerms && (
            <ModalTerms
              isOpen={openTerms}
              setIsOpen={setOpenTerms}
              termContent={term}
              backgroundButton={
                config?.webappcolor.webappbutton &&
                config.webappcolor.webappbutton
              }
              fontButton={
                config?.webappcolor.fontbutton && config.webappcolor.fontbutton
              }
              acceptTerm={acceptTerm}
              setAcceptTerm={setAcceptTerm}
            />
          )}
        </div>
      )}
    </div>
  );
}
